module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHN0eWxlPSJmaWxsOndoaXRlOyIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik05IDhoLTN2NGgzdjEyaDV2LTEyaDMuNjQybC4zNTgtNGgtNHYtMS42NjdjMC0uOTU1LjE5Mi0xLjMzMyAxLjExNS0xLjMzM2gyLjg4NXYtNWgtMy44MDhjLTMuNTk2IDAtNS4xOTIgMS41ODMtNS4xOTIgNC42MTV2My4zODV6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./static/icons/facebook.svg
// module id = 727
// module chunks = 168707334958949